import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { DropdownItem } from "@similarweb/ui-components";

export const StyledRegionDropdownContainer = styled.div`
    position: relative;
`;

export const StyledRegionDropdownItem = styled(DropdownItem)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 16px 0 10px;
`;

export const StyledRegionItemsDivider = styled.div`
    border-top: 1px solid ${colorsPalettes.carbon["100"]};
    margin: 12px 0;
    pointer-events: none;
    width: 98%;
    display: flex;
    justify-self: center;
`;
